const deliveryMenKeys = {
  module: ['deliveryMen'] as const,
  list: () => [...deliveryMenKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...deliveryMenKeys.list(), filters] as const,
  details: (id: string) => [...deliveryMenKeys.module, 'details', id] as const,
};

export default deliveryMenKeys;
